"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ng_drag_drop_module_1 = require("./src/ng-drag-drop.module");
exports.NgDragDropModule = ng_drag_drop_module_1.NgDragDropModule;
var drop_event_model_1 = require("./src/shared/drop-event.model");
exports.DropEvent = drop_event_model_1.DropEvent;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-drag-drop/index.js
// module id = 348
// module chunks = 1